import React from "react";
import {
  BarChart, Bar, XAxis, YAxis, Tooltip, ResponsiveContainer, CartesianGrid, Legend
} from "recharts";
import { Paper, Typography } from "@mui/material";
import ErrorOutlineIcon from "@mui/icons-material/ErrorOutline";


const Projects_budget_ByDirection_charts = ({ projects, directions }) => {
  if (!projects || projects.length === 0) {
    return (
      <Paper
        elevation={3}
        sx={{
          p: 2,
          height: "100%",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        <Typography align="center">
          <ErrorOutlineIcon sx={{ mr: 1, verticalAlign: "middle" }} />
          Aucun projet trouvé.
        </Typography>
      </Paper>
    );
  }
  const formattedData = projects.map((project) => ({
    name: get_direction_title(project.direction, directions)??"Non spécifiée",
    estimated_budget: project.total_estimated,
    committed_budget: project.total_committed,
    realised_budget: project.total_realized
  }));

  function get_direction_title(id, directions) {
    let dir_title = null;
    for (let dir of directions) {
      if (dir.id == id) { dir_title = dir.title; break; }
    }
    return dir_title;
  }
  return (
    <Paper elevation={3} sx={{ p: 3, borderRadius: 2, height: "100%" }}>
      <ResponsiveContainer width="100%" height={350}>
        <BarChart
          data={formattedData}
          layout="vertical"
          margin={{ top: 20, right: 100, left: 40, bottom: 20 }}
        >
          <CartesianGrid strokeDasharray="3 3" />
          <XAxis type="number" />
          <YAxis dataKey="name" type="category" width={120} />
          <Tooltip formatter={(value) => `${value.toLocaleString()} MAD`} />
          <Legend />
          <Bar dataKey="estimated_budget" fill="#90caf9" name="Budget Prévu" />
          <Bar dataKey="committed_budget" fill="#f3904aff" name="Budget Engagé" />
          <Bar dataKey="released_budget" fill="#ef4141ff" name="Budget Réalisé" />
        </BarChart>
      </ResponsiveContainer>
    </Paper>
  );
};

export default Projects_budget_ByDirection_charts;
